module.exports = __webpack_public_path__ + "img/emoji17.png";